import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose, Query, withApollo } from 'react-apollo'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import { Button, CardHeader, CardBody, Col, Row, Table } from 'reactstrap'
import { createOrUpdateGroupsMutation, GroupsFetchQuery, GroupPeopleQuery, SearchPeopleQuery, removePersonFromGroupMutation, addPersonToGroupMutation } from './mutations'
import CreatableSelect from '../Wps/CreatableSelect'
import _ from 'lodash'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'

const basicCheckbox = [{ name: 'Show', key: 'index' }, { name: 'Add', key: 'create' }, {
  name: 'Edit',
  key: 'update'
}, { name: 'Delete', key: 'destroy' }]
const peopleCheckbox = [...basicCheckbox.slice(0, -1),
{ name: 'a Person as a Welder', key: 'welder' }, { name: 'a Person as a Grinder', key: 'grinder' }, { name: 'a Person as a Foreman', key: 'foreman' }, { name: 'a Person as a Inspector', key: 'inspector' },
{ name: 'Anonymization', key: 'anonymize' }
]

const gridColumns = ['no', 'weld_type', 'length', 'diameter_1', 'thickness_1', 'diameter_2', 'thickness_2',
  'material_1', 'material_2', 'inspection_category', 'inspections', 'wps', 'welding_progress', 'last_welding_date', 'welder', 'welding_wps', 'welding_consumables', '$dimensional_control', 'status', 'blocked_for_import']

class GroupForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      validation_errors: null,
      permissions: (props.editData.permissions && JSON.parse(props.editData.permissions)) || {},
      allPeople: [],
      selectedToAdd: [],
      clonePeople: null,
      editPeople: null
    }

    this.submitFunction = this.submitFunction.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    afterSubmitFunction: PropTypes.func.isRequired,
    formToggleFunction: PropTypes.func.isRequired,
    clearFunction: PropTypes.func.isRequired,
    editData: PropTypes.object,
  }

  componentDidMount() {
    this.props.client.query({
      query: SearchPeopleQuery,
      variables: { filters: {}, size: 5000 },
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      this.setState({ allPeople: (data && data.people && data.people.list) || [] })
    })

    if (this.props.editData.clonedFromGroupId) {
      this.props.client.query({
        query: GroupPeopleQuery,
        variables: { group_id: this.props.editData.clonedFromGroupId },
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        this.setState({ clonePeople: (data && data.groupPeople) || [] })
      })
    }

    if (this.props.editData.id) {
      this.props.client.query({
        query: GroupPeopleQuery,
        variables: { group_id: this.props.editData.id },
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        this.setState({ editPeople: (data && data.groupPeople) || [] })
      })
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      permissions: (newProps.editData.permissions && JSON.parse(newProps.editData.permissions)) || {},
      selectedToAdd: [],
      clonePeople: null,
      editPeople: null
    })
  }

  componentWillUnmount() {
    this.props.clearFunction()
  }

  submitFunction(e, values) {
    // Filter out unsupported permissions for revision_logs and wps_logs
    let filteredPermissions = { ...this.state.permissions }
    if (filteredPermissions.wl_welds) {
      if (filteredPermissions.wl_welds.revision_logs) {
        const { create, update, ...allowedRevisionLogs } = filteredPermissions.wl_welds.revision_logs
        filteredPermissions.wl_welds.revision_logs = allowedRevisionLogs
      }
      if (filteredPermissions.wl_welds.wps_logs) {
        const { create: wpsCreate, update: wpsUpdate, ...allowedWpsLogs } = filteredPermissions.wl_welds.wps_logs
        filteredPermissions.wl_welds.wps_logs = allowedWpsLogs
      }
    }

    const clonedFromGroupId = this.props.editData.clonedFromGroupId
    const clonePeople = this.state.clonePeople

    this.props.mutate({
      variables: {
        id: this.props.editData.id ? this.props.editData.id : null,
        name: values.name,
        permissions: JSON.stringify(filteredPermissions)
      },
      update: (store, { data: { createOrUpdateGroups } }) => {
        if (!this.props.editData.id && !createOrUpdateGroups.errors) {
          const data = store.readQuery({ query: GroupsFetchQuery })
          data.groups.splice(0, 0, createOrUpdateGroups.group)
          store.writeQuery({
            query: GroupsFetchQuery,
            data,
          })
        }
      },
    }).then(({ data }) => {
      if (data.createOrUpdateGroups.errors) {
        this.setState({ validation_errors: data.createOrUpdateGroups.errors })
      } else {
        const newGroupId = data.createOrUpdateGroups.group.id
        if (clonedFromGroupId) {
          const doAssign = (people) => Promise.all(people.map(person =>
            this.props.addPersonToGroup({ variables: { group_id: newGroupId, person_id: person.id } })
          )).then(() => this.props.afterSubmitFunction())

          if (clonePeople !== null) {
            doAssign(clonePeople)
          } else {
            this.props.client.query({
              query: GroupPeopleQuery,
              variables: { group_id: clonedFromGroupId },
              fetchPolicy: 'network-only'
            }).then(({ data: pd }) => doAssign((pd && pd.groupPeople) || []))
          }
        } else {
          this.props.afterSubmitFunction()
        }
      }
    })
  }

  handleValueChange(value, path) {
    let newPerm = this.state.permissions
    let val = Array.isArray(value) ? value.map(val => val.name) : value
    this.setState({ permissions: _.set(newPerm, path, val) })
  }

  renderCheckboxes(keyTable, groupName, name) {
    return (
      keyTable.map(o => {
        let keyName = `${groupName}.${name}.${o.key}`
        return (
          <div key={keyName} className="GroupForm">
            <input type="checkbox"
              id={keyName}
              onChange={() => {
                this.handleValueChange(!_.get(this.state.permissions, keyName), keyName)
              }
              }
              checked={!!_.get(this.state.permissions, keyName)}
            />
            <label htmlFor={keyName}> {o.name}</label>
          </div>)
      })
    )
  }

  renderAddPerson(groupId, isClone, currentPeopleIds) {
    const options = this.state.allPeople
      .filter(p => !currentPeopleIds.includes(p.id))
      .map(p => ({ ...p, name: `${p.uuid} – ${p.first_name} ${p.last_name}` }))

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px', width: '40%' }}>
        <div style={{ flex: 1 }}>
          <CreatableSelect
            label={null}
            id="add-person-to-group"
            options={options}
            valueKey="id"
            labelKey="name"
            value={this.state.selectedToAdd}
            multi={true}
            creatable={false}
            placeholder="Add people..."
            valueChangeFunction={val => this.setState({ selectedToAdd: val || [] })}
          />
        </div>
        <Button type="button" color="success" disabled={!this.state.selectedToAdd.length}
          onClick={() => {
                if (isClone) {
                  const personToAdd = this.state.allPeople.find(p => this.state.selectedToAdd.map(s => s.id).includes(p.id))
                  const newPeople = [...(this.state.clonePeople || [])]
                  this.state.selectedToAdd.forEach(s => {
                    if (!newPeople.find(p => p.id === s.id)) newPeople.push(s)
                  })
                  this.setState({ clonePeople: newPeople, selectedToAdd: [] })
                } else {
                  Promise.all(this.state.selectedToAdd.map(person =>
                    this.props.addPersonToGroup({
                      variables: { group_id: groupId, person_id: person.id }
                    })
                  )).then(() => this.setState({
                    editPeople: [...(this.state.editPeople || []), ...this.state.selectedToAdd.filter(s => !(this.state.editPeople || []).find(p => p.id === s.id))],
                    selectedToAdd: []
                  }))
                }
              }}>
              Add
          </Button>
      </div>
    )
  }


  render() {
    return (
      <div>
        <CardHeader>{this.props.editData.id ? 'Edit Group' : 'Add new Group'}</CardHeader>
        <CardBody>
          {this.state.validation_errors &&
            <h4 className="errors-heading">{this.state.validation_errors.join(', ')}</h4>
          }
          <AvForm id="group-form" onValidSubmit={this.submitFunction} className="FormClassLabel">
            <Row>
              <Col xs="12" sm="4">
                <AvField
                  id="name-group-form"
                  name="name"
                  label="Name"
                  type="text"
                  value={this.props.editData.name || ''}
                  required
                />
              </Col>
            </Row>

            <Row>
              <Col xs="12" sm="3">
                {this.renderCheckboxes([{ name: 'Show Dashboard', key: 'dasboard' }], 'core', 'dasboard')}
              </Col>
              <Col xs="12" sm="3">
                <h5>People:</h5>
                {this.renderCheckboxes([{ name: 'Show people list', key: 'show_people_list' }], 'core', 'show_people_list')}
                {this.renderCheckboxes(peopleCheckbox, 'core', 'people')}
              </Col>
              <Col xs="12" sm="3">
                <h5>Users:</h5>
                {this.renderCheckboxes(basicCheckbox.slice(1, -1), 'core', 'users')}
              </Col>
              <Col xs="12" sm="3">
                <h5>Groups:</h5>
                {this.renderCheckboxes(basicCheckbox.slice(1, -1), 'core', 'groups')}
              </Col>

            </Row>

            <br />

            <Row>
              <Col xs="12" sm="3">
                <h5>Companies:</h5>
                {this.renderCheckboxes(basicCheckbox.slice(0, -1), 'core', 'companies')}
              </Col>
              <Col xs="12" sm="3">
                <h5>Projects:</h5>
                {this.renderCheckboxes(basicCheckbox, 'wl_welds', 'projects')}
                {this.renderCheckboxes([{ name: 'Show comapnies on project list', key: 'show_companies' }], 'wl_welds', 'show_companies')}
                {this.renderCheckboxes([{ name: 'Show dates on planned on project list', key: 'show_planned_dates' }], 'wl_welds', 'show_planned_dates')}
                {this.renderCheckboxes([{ name: 'Show dates welding progress on project list', key: 'show_welding_progress' }], 'wl_welds', 'show_welding_progress')}
                {this.renderCheckboxes([{ name: 'Show dates inspection progress on project list', key: 'show_inspection_progress' }], 'wl_welds', 'show_inspection_progress')}
                {this.renderCheckboxes([{ name: 'Show project elements', key: 'show_project_elements' }], 'wl_welds', 'show_project_elements')}
                {this.renderCheckboxes([{ name: 'Show project welds', key: 'show_project_welds' }], 'wl_welds', 'show_project_welds')}
                {this.renderCheckboxes([{ name: 'Show project NDT', key: 'show_project_ndt' }], 'wl_welds', 'show_project_ndt')}
                {this.renderCheckboxes([{ name: 'Show project grouping welds', key: 'show_project_grouping_welds' }], 'wl_welds', 'show_project_grouping_welds')}
                {this.renderCheckboxes([{ name: 'Show project details configuration', key: 'show_details_project_configuration' }], 'wl_welds', 'show_details_project_configuration')}
                {this.renderCheckboxes([{ name: 'Show user project configuration', key: 'show_user_project_configuration' }], 'wl_welds', 'show_user_project_configuration')}
                {this.renderCheckboxes([{ name: 'Show inspection category configuration', key: 'show_inspection_category_configuration' }], 'wl_welds', 'show_inspection_category_configuration')}
                {this.renderCheckboxes([{ name: 'Generate final report', key: 'generate_final_report' }], 'wl_welds', 'generate_final_report')}
              </Col>
              <Col xs="12" sm="3">
                <h5>WPS:</h5>
                {this.renderCheckboxes([{ name: 'Show WPS list', key: 'show_wps_list' }], 'wl_welds', 'show_wps_list')}
                {this.renderCheckboxes(basicCheckbox, 'wl_welds', 'wps')}
                {this.renderCheckboxes([{ name: 'Assign WPS to projects', key: 'assign_projects' }], 'wl_welds', 'wps')}
                {this.renderCheckboxes([{ name: 'Export WPS list', key: 'export_wps_list' }], 'wl_welds', 'export_wps_list')}
                {this.renderCheckboxes([{ name: 'Import from PDF', key: 'import_wps_pdf' }], 'wl_welds', 'import_wps_pdf')}
              </Col>
              <Col xs="12" sm="3">
                <h5>Welds:</h5>
                {this.renderCheckboxes(basicCheckbox.slice(1), 'wl_welds', 'welds')}
                {this.renderCheckboxes([{ name: 'Block for import', key: 'block' }], 'wl_welds', 'welds')}
                {this.renderCheckboxes([{ name: 'Import welds', key: 'import_welds' }], 'wl_welds', 'import_welds')}
                {this.renderCheckboxes([{ name: 'Export welds', key: 'export_welds' }], 'wl_welds', 'export_welds')}
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="3">
                <h5>Welder certificates:</h5>
                {this.renderCheckboxes([{ name: 'Show certificates list', key: 'show_certificates_list' }], 'wl_welders', 'show_certificates_list')}
                {this.renderCheckboxes(basicCheckbox, 'wl_welders', 'certificates')}
                {this.renderCheckboxes([{ name: 'Add confirmation', key: 'add_confirmation' }], 'wl_welders', 'certificates')}
                {this.renderCheckboxes([{ name: 'Export certificates list', key: 'export_certificates_list' }], 'wl_welders', 'export_certificates_list')}
              </Col>
              <Col xs="12" sm="6">
                <h5>Show reports:</h5>
                {this.renderCheckboxes([{ name: 'Show reports list', key: 'show_reports_list' }], 'core', 'show_reports_list')}
                {this.renderCheckboxes([{ name: 'Work progress', key: 'work_progress' }], 'core', 'work_progress')}
                {this.renderCheckboxes([{ name: 'Report project defectiveness', key: 'report_project_defectiveness' }], 'core', 'report_project_defectiveness')}
                {this.renderCheckboxes([{ name: 'Report welder defectiveness', key: 'report_welder_defectiveness' }], 'core', 'report_welder_defectiveness')}
                {this.renderCheckboxes([{ name: 'Completion forecast', key: 'completion_forecast' }], 'core', 'completion_forecast')}
                {this.renderCheckboxes([{ name: 'Defectiveness trend', key: 'defectiveness_trend' }], 'core', 'defectiveness_trend')}
                {this.renderCheckboxes([{ name: 'Welder benchmark', key: 'welder_benchmark' }], 'core', 'welder_benchmark')}
                {this.renderCheckboxes([{ name: 'Inspection backlog', key: 'inspection_backlog' }], 'core', 'inspection_backlog')}
                {this.renderCheckboxes([{ name: 'Section progress', key: 'section_progress' }], 'core', 'section_progress')}
                {this.renderCheckboxes([{ name: 'WPS usage', key: 'wps_usage' }], 'core', 'wps_usage')}
                {this.renderCheckboxes([{ name: 'Repair analysis', key: 'repair_analysis' }], 'core', 'repair_analysis')}
                {this.renderCheckboxes([{ name: 'Daily burn rate', key: 'daily_burn_rate' }], 'core', 'daily_burn_rate')}
                {this.renderCheckboxes([{ name: 'Weld lead time', key: 'weld_lead_time' }], 'core', 'weld_lead_time')}
                {this.renderCheckboxes([{ name: 'Grouping savings', key: 'grouping_savings' }], 'core', 'grouping_savings')}
              </Col>
              <Col xs="12" sm="3">
                <h5>Comments:</h5>
                {this.renderCheckboxes(basicCheckbox, 'core', 'comments')}
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs="12" sm="3">
                <h5>Revision logs:</h5>
                {this.renderCheckboxes([{ name: 'Show', key: 'index' }, { name: 'Delete', key: 'destroy' }], 'wl_welds', 'revision_logs')}
              </Col>

              <Col xs="12" sm="3">
                <h5>WPS logs:</h5>
                {this.renderCheckboxes([{ name: 'Show', key: 'index' }, { name: 'Delete', key: 'destroy' }], 'wl_welds', 'wps_logs')}
              </Col>

              <Col xs="12" sm="3">
                <h5>Welding logs:</h5>
                {this.renderCheckboxes(basicCheckbox, 'wl_welds', 'welding_logs')}
              </Col>

              <Col xs="12" sm="3">
                <h5>Grinding logs:</h5>
                {this.renderCheckboxes(basicCheckbox, 'wl_welds', 'grinding_logs')}
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="3">
                <h5>Inspection logs:</h5>
                {this.renderCheckboxes(basicCheckbox, 'wl_welds', 'inspection_logs')}
                {this.renderCheckboxes([{ name: 'Bypass hold time', key: 'bypass_hold_time' }], 'wl_welds', 'inspection_logs')}
              </Col>
              <Col xs="12" sm="3">
                <h5>Dimensional Control logs:</h5>
                {this.renderCheckboxes(basicCheckbox, 'wl_welds', 'dimensional_control_logs')}
              </Col>
              <Col xs="12" sm="3">
              </Col>
              <Col xs="12" sm="3">
                <h5>Permanent deletion:</h5>
                {this.renderCheckboxes([{ name: 'Welds', key: 'welds' }], 'wl_welds', 'permanent_deletion')}
              </Col>
            </Row>

            <br />

            <Row>
              <Col xs="12" sm="6">

                <CreatableSelect label="Avalible grid columns" id="select-grid-columns-group-form"
                  options={gridColumns.map(name => ({ name: name }))}
                  valueKey="name"
                  value={_.get(this.state.permissions, 'wl_welds.welds.grid_columns')}
                  multi={true}
                  creatable={false}
                  valueChangeFunction={val => {
                    this.handleValueChange(val, 'wl_welds.welds.grid_columns')
                  }} />
              </Col>
            </Row>

            <br /> <br />
          </AvForm>

          {(this.props.editData.id || this.props.editData.clonedFromGroupId) && (
            <div>
              <h5>{this.props.editData.clonedFromGroupId && !this.props.editData.id ? 'People to be assigned (from cloned group)' : 'People in this group'}</h5>
              <Query query={GroupPeopleQuery} variables={{ group_id: this.props.editData.id || this.props.editData.clonedFromGroupId }} fetchPolicy="network-only">
                {({ loading }) => {
                  const { id, clonedFromGroupId } = this.props.editData
                  const isClone = !id && !!clonedFromGroupId
                  const people = isClone ? (this.state.clonePeople || []) : (this.state.editPeople || [])
                  const currentPeopleIds = people.map(p => p.id)
                  return (
                    <div>
                      {this.renderAddPerson(id || clonedFromGroupId, isClone, currentPeopleIds)}
                      {loading && (this.state.clonePeople === null && this.state.editPeople === null) && <p className="text-muted">Loading...</p>}
                      {people.length === 0 && !loading && <p className="text-muted">No people assigned to this group.</p>}
                      {people.length > 0 && (
                        <Table hover responsive size="sm">
                          <thead>
                            <tr>
                              <th>UUID</th>
                              <th>Name</th>
                              <th style={{ width: '60px' }} />
                            </tr>
                          </thead>
                          <tbody>
                            {people.map(person => (
                              <tr key={person.id}>
                                <td>{person.uuid}</td>
                                <td>{person.first_name} {person.last_name}</td>
                                <td>
                                  <Button type="button" size="sm" color="danger" title="Remove from group" onClick={() => {
                                    if (isClone) {
                                      this.setState({ clonePeople: this.state.clonePeople.filter(p => p.id !== person.id) })
                                    } else {
                                      this.props.removePersonFromGroup({
                                        variables: { group_id: id, person_id: person.id }
                                      })
                                      this.setState({ editPeople: this.state.editPeople.filter(p => p.id !== person.id) })
                                    }
                                  }}>
                                    <i className="fa fa-times" />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  )
                }}
              </Query>
            </div>
          )}

          <Button id="close-group-form-btn" color="danger" className="float-right"
            onClick={this.props.formToggleFunction}>
            <i className="fa fa-close" /> Close
          </Button>
          <Button id="save-group-form-btn" type="submit" form="group-form" color="primary" className="float-right">
            <i className="fa fa-plus" /> Save
          </Button>
          <br /> <br />
        </CardBody>
      </div>
    )
  }
}

const GroupFormWithMutation = compose(
  graphql(createOrUpdateGroupsMutation),
  graphql(removePersonFromGroupMutation, { name: 'removePersonFromGroup' }),
  graphql(addPersonToGroupMutation, { name: 'addPersonToGroup' })
)(GroupForm)

export default withApollo(GroupFormWithMutation)



// WEBPACK FOOTER //
// ./src/components/People/GroupForm.js